<template>
  <div class="create-cutting-tangent">
    <div class="breadcrumb" v-if="$route.path === '/createcuttingtangent'">{{ $route.query.id ? '编辑' : '添加' }}合成区类型</div>
    <div class="order-detail-basic">
      <el-form hide-required-asterisk ref="createForm" :model="areatingInfo" :rules="createRules" label-width="200px">
        <el-form-item label="合成区区域名称:" prop="areaName">
          <el-input v-model="areatingInfo.areaName" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="规格:">
          <div style="display: flex">
            <div class="spec-mm">
              <el-form-item label="上:" label-width="20px" style="margin:0" prop="areaTop">
                <el-input placeholder="" v-model="areatingInfo.areaTop">
                  <template slot="append">mm</template>
                </el-input>
              </el-form-item>
            </div>
            <div class="spec-mm">
              <el-form-item label="下:" label-width="20px" style="margin:0" prop="areaBottom">
                <el-input placeholder="" v-model="areatingInfo.areaBottom">
                  <template slot="append">mm</template>
                </el-input>
              </el-form-item>
            </div>
          </div>
          <div style="display: flex;margin-top: 20px">
            <div class="spec-mm">
              <el-form-item label="左:" label-width="20px" style="margin:0" prop="areaLeft">
                <el-input placeholder="" v-model="areatingInfo.areaLeft">
                  <template slot="append">mm</template>
                </el-input>
              </el-form-item>
            </div>
            <div class="spec-mm">
              <el-form-item label="右:" label-width="20px" style="margin:0" prop="areaRight">
                <el-input placeholder="" v-model="areatingInfo.areaRight">
                  <template slot="append">mm</template>
                </el-input>
              </el-form-item>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="合成信息位置:" prop="barcodePosition">
          <el-select v-model="areatingInfo.barcodePosition">
            <el-option label="上" value="TOP"></el-option>
            <el-option label="下" value="BOTTOM"></el-option>
            <el-option label="左" value="LEFT"></el-option>
            <el-option label="右" value="RIGHT"></el-option>
            <el-option label="奇右偶左" value="ODD_RIGHT_EVEN_LEFT"></el-option>
          </el-select>
          <el-form-item label="靠边:" style="display:inline-block;margin-right:0;" prop="marginSize" label-width="50px">
            <el-input placeholder="" v-model="areatingInfo.marginSize">
              <template slot="append">mm</template>
            </el-input>
          </el-form-item>
          <el-form-item label="字号:" style="display:inline-block;margin-right:0;" prop="fontSize" label-width="50px">
            <el-input placeholder="" style="width:80px;" v-model="areatingInfo.fontSize"></el-input>
          </el-form-item>
        </el-form-item>
        <el-form-item label="合成区任务码:" style="display:inline-block;margin-right:0;">
          <el-form-item label="宽度:" style="display:inline-block;margin-right:0;" label-width="50px" prop="jobCodeWidth">
            <el-input placeholder="" style="width:150px;" v-model="areatingInfo.jobCodeWidth">
              <template slot="append">mm</template>
            </el-input>
          </el-form-item>
          <el-form-item label="高度:" style="display:inline-block;margin-right:0;" label-width="50px" prop="jobCodeHeight">
            <el-input placeholder="" style="width:150px;" v-model="areatingInfo.jobCodeHeight">
              <template slot="append">mm</template>
            </el-input>
          </el-form-item>
          <el-form-item label="合成信息后是否加码:" style="display:inline-block;margin-right:0;" label-width="150px">
            <el-radio-group v-model="areatingInfo.composeAfterCodeIsAppear">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form-item>
        <el-form-item label="左侧合成码:" prop="leftComposeCode">
          <el-select v-model="areatingInfo.leftComposeCode">
            <el-option v-for="(v, k) in $config.leftComposeCode" :key="k" :label="v" :value="k"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="裁切线设置:" prop="cornerMargin">
          <el-input placeholder="" style="width:150px;" v-model="areatingInfo.cornerMargin">
            <template slot="append">mm</template>
          </el-input>
        </el-form-item>
        <el-form-item label="合成黑边:">
          <el-checkbox-group v-model="blackBorder">
            <el-checkbox :label="1">上</el-checkbox>
            <el-checkbox :label="2">下</el-checkbox>
            <el-checkbox :label="3">左</el-checkbox>
            <el-checkbox :label="4">右</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
    </div>
    <div class="form-btn" style="margin: 20px 0">
      <el-button round type="primary" @click="save">确定</el-button>
    </div>
  </div>
</template>
<script>
import { areaDetail, areaUsable, areaUpdate, areaAdd } from '@/api/pms'
export default {
  name: 'create-cutting-tangent',
  data () {
    var checkTop = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error('请输入距上规格'))
      } else if (!this.$reg.area.reg.test(value) && String(value).indexOf('.') > -1) {
        return callback(new Error(this.$reg.area.message))
      } else {
        callback()
      }
    }
    var checkBottom = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error('请输入距下规格'))
      } else if (!this.$reg.area.reg.test(value) && String(value).indexOf('.') > -1) {
        return callback(new Error(this.$reg.area.message))
      } else {
        callback()
      }
      // else if (value < 0) {
      //   return callback(new Error('请输入大于等于0的值'))
      // }
    }
    var checkLeft = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error('请输入距左规格'))
      } else if (!this.$reg.area.reg.test(value) && String(value).indexOf('.') > -1) {
        return callback(new Error(this.$reg.area.message))
      } else {
        callback()
      }
      // else if (value < 0) {
      //   return callback(new Error('请输入大于等于0的值'))
      // } 
    }
    var jobCodeWidth = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error('请输入宽度'))
      } else if (value < 0) {
        return callback(new Error('请输入大于等于0的值'))
      } else if (!this.$reg.area.reg.test(value)) {
        return callback(new Error(this.$reg.area.message))
      } else {
        callback()
      }
    }
    var jobCodeHeight = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error('请输入高度'))
      } else if (value < 0) {
        return callback(new Error('请输入大于等于0的值'))
      } else if (!this.$reg.area.reg.test(value)) {
        return callback(new Error(this.$reg.area.message))
      } else {
        callback()
      }
    }
    var cornerMargin = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error('请输入裁切线设置'))
      } else if (value < 0) {
        return callback(new Error('请输入大于等于0的值'))
      } else if (!this.$reg.area.reg.test(value)) {
        return callback(new Error(this.$reg.area.message))
      } else {
        callback()
      }
    }
    var marginSize = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error('未输入'))
      } else if (value <= 0) {
        return callback(new Error('请输入大于等于0的值'))
      } else if (!this.$reg.area.reg.test(value)) {
        return callback(new Error(this.$reg.area.message))
      } else {
        callback()
      }
    }
    var fontSize = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error('未输入字号'))
      } else if (value <= 0 || /[^\d]/g.test(value)) {
        return callback(new Error('请输入大于等于0的数字'))
      } else {
        callback()
      }
    }
    var checkRight = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error('请输入距右规格'))
      } else if (!this.$reg.area.reg.test(value) && String(value).indexOf('.') > -1) {
        return callback(new Error(this.$reg.area.message))
      } else {
        callback()
      }
      //  else if (value < 0) {
      //   return callback(new Error('请输入大于等于0的值'))
      // } 
    }
    return {
      blackBorder: [1, 2, 3, 4],
      addareaLineName: '',
      areatingInfo: {
        cornerMargin: '8',
        marginSize: '1',
        fontSize: '32',
        composeAfterCodeIsAppear: false,
        barcodePosition: '',
        areaBottom: '',
        areaLeft: '',
        areaName: '',
        areaRight: '',
        areaTop: '',
        jobCodeWidth: '50',
        jobCodeHeight: '5',
        leftComposeCode: ''
        // machineCodeIsAppear: '',
        // jobCodeIsAppear: ''
      },
      createRules: {
        areaName: [
          { required: true, message: '请输入合成区区域名称', trigger: 'blur' }
        ],
        areaTop: [
          { validator: checkTop, trigger: 'blur' }
        ],
        areaBottom: [
          { validator: checkBottom, trigger: 'blur' }
        ],
        areaLeft: [
          { validator: checkLeft, trigger: 'blur' }
        ],
        areaRight: [
          { validator: checkRight, trigger: 'blur' }
        ],
        barcodePosition: [
          { required: true, message: '请选择条码位置', trigger: 'change' }
        ],
        jobCodeWidth: [
          { validator: jobCodeWidth, trigger: 'blur' }
        ],
        jobCodeHeight: [
          { validator: jobCodeHeight, trigger: 'blur' }
        ],
        cornerMargin: [
          { validator: cornerMargin, trigger: 'blur' }
        ],
        fontSize: [
          { validator: fontSize, trigger: 'blur' }
        ],
        leftComposeCode: [
          { required: true, message: '请选择左侧合成码', trigger: 'change' }
        ]
        // jobCodeIsAppear: [
        //   { required: true, message: '请选择任务码是否出现', trigger: 'change' }
        // ],
        // machineCodeIsAppear: [
        //   { required: true, message: '请选择机器码是否出现', trigger: 'change' }
        // ]
      }
    }
  },
  mounted () {
    sessionStorage.setItem('searchFlag', true)
  },
  created () {
    this.getEditInfo()
  },
  methods: {
    getEditInfo () {
      if (!this.$route.query.id || this.$route.path !== '/createcuttingtangent') {
        return
      }
      areaDetail(this.$route.query.id).then((res) => {
        if (res.data.success) {
          this.areatingInfo = res.data.data
          console.log('this.areatingInfo', this.areatingInfo)
          this.blackBorder = []
          if (this.areatingInfo.blackBorderTop) {
            this.blackBorder.push(1)
          }
          if (this.areatingInfo.blackBorderBottom) {
            this.blackBorder.push(2)
          }
          if (this.areatingInfo.blackBorderLeft) {
            this.blackBorder.push(3)
          }
          if (this.areatingInfo.blackBorderRight) {
            this.blackBorder.push(4)
          }
          this.areatingInfo.blackBorderBottom = this.areatingInfo.blackBorderBottom ? 1 : 0
          this.areatingInfo.blackBorderLeft = this.areatingInfo.blackBorderLeft ? 1 : 0
          this.areatingInfo.blackBorderRight = this.areatingInfo.blackBorderRight ? 1 : 0
          this.areatingInfo.blackBorderTop = this.areatingInfo.blackBorderTop ? 1 : 0
          // this.blackBorder=
          // this.areatingInfo.areaName = res.data.data.areaName
          // this.areatingInfo.areaTop = res.data.data.areaTop
          // this.areatingInfo.areaRight = res.data.data.areaRight
          // this.areatingInfo.areaLeft = res.data.data.areaLeft
          // this.areatingInfo.areaBottom = res.data.data.areaBottom
          // this.areatingInfo.barcodePosition = res.data.data.barcodePosition
          // this.areatingInfo.machineCodeIsAppear = res.data.data.machineCodeIsAppear
          // this.areatingInfo.jobCodeIsAppear = res.data.data.jobCodeIsAppear
        }
      })
    },
    save () {
      this.$refs.createForm.validate((valid) => {
        if (!valid) {
          return
        }
        this.areatingInfo.blackBorderTop = this.blackBorder.indexOf(1) !== -1 ? 1 : 0
        this.areatingInfo.blackBorderBottom = this.blackBorder.indexOf(2) !== -1 ? 1 : 0
        this.areatingInfo.blackBorderLeft = this.blackBorder.indexOf(3) !== -1 ? 1 : 0
        this.areatingInfo.blackBorderRight = this.blackBorder.indexOf(4) !== -1 ? 1 : 0
        if (this.$route.query.id && this.$route.path === '/createcuttingtangent') {
          areaUsable({ act: 1, areaId: this.$route.query.id, areaName: this.areatingInfo.areaName }).then((res) => {
            if (res.data.success) {
              areaUpdate({ areaId: this.$route.query.id, areaLineVo: this.areatingInfo }).then((res) => {
                if (res.data.success) {
                  this.$message.success('编辑合成区类型成功')
                  this.$router.go(-1)
                }
              })
            }
          })
        } else {
          areaUsable({ act: 0, areaName: this.areatingInfo.areaName }).then((res) => {
            if (res.data.success) {
              areaAdd(this.areatingInfo).then((res) => {
                if (res.data.success) {
                  this.$message.success('新建合成区类型成功')
                  if (this.$route.path === '/createcuttingtangent') {
                    this.$router.push('/cuttingtangent')
                  } else {
                    this.$emit('save', this.areatingInfo.areaName)
                  }
                  // this.$emit('isShow')
                }
              })
            }
          })
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
@deep: ~">>>";

.create-cutting-tangent {
  .spec-mm {
    span {
      margin-right: 10px;
    }

    .el-input {
      width: auto;

      @{deep} .el-input__inner {
        width: 65px;
      }
    }

    @{deep} .el-input-group__append {
      padding: 0 15px;
    }
  }
}

@{deep} .order-detail-basic .el-form .el-form-item {
  margin-left: 15px;
}

.preview_box {
  width: 380px;
  height: 258px;
  border: 1px solid #000;
  position: relative;

  .preview_content {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    width: 324px;
    height: 202px;
    background: rgba(215, 215, 215, 1);
  }

  img {
    width: 149px;
    position: absolute;
  }

  .top {
    top: 7px;
    left: 30px;
  }

  .bottom {
    bottom: 5px;
    left: 30px;
  }

  .left {
    transform: rotateZ(-90deg);
    left: -56px;
    top: 145px;
  }

  .right {
    transform: rotateZ(-90deg);
    right: -65px;
    top: 145px;
  }
}
</style>
